/**
 * Bytes a `keepalive` request body may hold. Browsers refuse a keepalive request once the in-flight keepalive bodies
 * pass 64 KB (Chrome throws a TypeError), so this leaves headroom for a second request in flight.
 */
export const keepaliveBodyLimit = 60_000

/**
 * Whether a request with this JSON body can be sent with `keepalive`, so it outlives the page: a write sent just
 * before the tab closed or reloaded was aborted with it, and the offline queue never saw it (GH #2476).
 */
export const canKeepAlive = (body: unknown) =>
  body === undefined || new TextEncoder().encode(JSON.stringify(body)).length < keepaliveBodyLimit
